import React from 'react'

import { withRouter } from 'react-router-dom'

import { Container, Icon, Dropdown, Divider, Header, Card, Popup, Label } from 'semantic-ui-react';
import { Section, Aligner, Properties, InfosBar, Timestamp } from 'components';

import { BreadcrumbHelper, uTimestamp } from 'utils';

import { API, Auth } from 'services';

import { EnumExamenType, EnumGait, EnumGround, EnumFigure } from 'enums';

import { Env } from 'env';

import moment from 'moment';

import './style.css';

class ExamenScene extends React.Component {

  constructor(props) {
    super(props);

    this.handleDropDownItemClick = this.handleDropDownItemClick.bind(this);
  }

  componentWillMount() {
    this.updateBreadcrumb();
  }

  updateBreadcrumb() {

    const { examen } = this.props;
    const { horse } = examen;
    const { clinic } = horse;

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');

    // Clinic mode
    if (this.props.match.path.startsWith('/clinics/')) {

      BreadcrumbHelper.push('Chevaux', '/clinics/horses');
      BreadcrumbHelper.push(horse.name, `/clinics/horses/${horse.uuid}`);
      BreadcrumbHelper.push('Examens', `/clinics/horses/${horse.uuid}#examens`);

    } else {

      BreadcrumbHelper.push('Cliniques', '/clinics');
      BreadcrumbHelper.push(clinic.name, `/clinics/${clinic.id}`);

      BreadcrumbHelper.push('Chevaux', `/clinics/${clinic.id}#horses`);
      BreadcrumbHelper.push(horse.name, `/horses/${horse.uuid}`);

      BreadcrumbHelper.push('Examens', `/horses/${horse.uuid}#examens`);
    }

    BreadcrumbHelper.push(moment.unix(examen.date_create).format('DD/MM/YYYY [à] HH:mm:ss'));

    BreadcrumbHelper.flush();
  }

  handleDropDownItemClick(format) {

    const { examen } = this.props;

    let params = {
      version: Env.API_VERSION,
      format: format
    };

    window.open(API.url(`examens/${examen.uuid}/download/extract`, true, params));
  }

  render() {

    const { examen } = this.props;

    var conditions = examen.conditions;

    //let new_cond = JSON.parse(JSON.stringify(conditions[0]));
    //new_cond.timestamp_start.unix = conditions[0].timestamp_start.unix + 1000;
    //conditions.push(new_cond);

    conditions.sort(function(a, b) {
      var keyA = new Date(a.timestamp_start.unix),
        keyB = new Date(b.timestamp_stop.unix);
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });


    let properties = [
      {
        name: 'Type',
        value: EnumExamenType.litteral(examen.type, examen.anesthesia_member, examen.anesthesia_type, examen.anesthesia_location)
      },
      {
        name: 'Date',
        value: moment.unix(uTimestamp.unix(examen.timestamp_start)).format('DD/MM/YYYY HH:mm')
      },
      {
        name: 'Durée',
        value: <Timestamp start={examen.timestamp_start} stop={examen.timestamp_stop} />
      }
    ];

    return (
      <React.Fragment>

        {/* Informations */}
        <Container>

          <Section title="Informations" actions={[]}>
            <Properties properties={properties} />
          </Section>

        </Container>

        <Container>

          <Divider horizontal>
            <Header as='h4'>
              <Icon name='tasks' />
              Conditions
            </Header>
          </Divider>

          <InfosBar mode="column">
            <span>{conditions.length > 1 ? `${conditions.length} conditions disponibles` : '1 condition disponible'}</span>

            {/* Export */}
            {Auth.hasRole(Auth.ROLE_MANAGER) &&
              <Dropdown trigger={
                <span>
                  <Icon name="download" />
                    Exporter les données
                </span>
              }>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => this.handleDropDownItemClick('bin')} text='Binaires' description='.bin' />
                  <Dropdown.Item onClick={() => this.handleDropDownItemClick('csv')} text='CSV' description='.csv' />
                </Dropdown.Menu>
              </Dropdown>
            }

          </InfosBar>

          {conditions.map((condition) => {

            return (
              <Card fluid raised>
                <Card.Content>
                  <Card.Header>
                    <Aligner horizontal="space-between">
                      <span>{`${EnumGait.short(condition.gait)}/${EnumGround.short(condition.ground, condition.ground_custom)}/${EnumFigure.short(condition.figure, condition.figure_custom)}`}</span>

                      {/* Video */}
                      {condition.video &&
                        <Popup
                          trigger={<Label as='a' corner="right" icon="video" color="green" onClick={() => window.open(API.url(`examens/videos/${condition.video.uuid}`, true))} />}
                          content='Télécharger la vidéo'
                          position='bottom left'
                          inverted
                          size="mini"
                        />
                      }

                    </Aligner>
                  </Card.Header>

                </Card.Content>
                <Card.Content extra>

                  <Aligner className="timeline" horizontal="space-between">

                    {/* Start */}
                    <span>{moment.unix(uTimestamp.unix(condition.timestamp_start)).format('DD/MM/YYYY HH:mm:ss.SSS')}</span>

                    <span className="separator" />

                    {/* Duration */}
                    <Timestamp start={condition.timestamp_start} stop={condition.timestamp_stop} />

                    <span className="separator" />

                    {/* Stop */}
                    <span>{moment.unix(uTimestamp.unix(condition.timestamp_stop)).format('DD/MM/YYYY HH:mm:ss.SSS')}</span>
                  </Aligner>

                </Card.Content>
              </Card>
            )
          })}

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(ExamenScene);
